import React, { useState, useEffect } from "react";
import { FiMenu } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import styles from "./DashboardLayout.module.css";

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 1024 : true,
  );
  const [sidebarOpen, setSidebarOpen] = useState(isDesktop);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleResize = () => {
    const desktop = window.innerWidth >= 1024;
    setIsDesktop(desktop);
    if (desktop) setSidebarOpen(true);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeSidebar = () => {
    if (!isDesktop) setSidebarOpen(false);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    // Clear user session
    localStorage.removeItem("user");
    localStorage.removeItem("authToken"); // <-- important

    // Trigger custom event so ProtectedRoute updates immediately
    window.dispatchEvent(new Event("storage"));
    window.dispatchEvent(new Event("userUpdated"));

    setShowLogoutModal(false);
    navigate("/primecloudsystems-login-989", { replace: true }); // Redirect to login page
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <div className={styles.dashboardLayout}>
      {!isDesktop && !sidebarOpen && (
        <button
          className={styles.sidebarOpenButton}
          onClick={() => setSidebarOpen(true)}
        >
          <FiMenu size={20} /> Menu
        </button>
      )}

      {!isDesktop && sidebarOpen && (
        <div className={styles.overlay} onClick={closeSidebar}></div>
      )}

      <div className={styles.mainLayout}>
        <aside
          className={`${styles.sidebarContainer} ${
            sidebarOpen ? styles.sidebarVisible : styles.sidebarHidden
          } ${isDesktop ? styles.desktopSidebar : ""}`}
        >
          <Sidebar
            onLinkClick={closeSidebar}
            showCloseButton={!isDesktop}
            onCloseSidebar={closeSidebar}
            onLogout={handleLogout}
          />
        </aside>

        <main className={styles.content}>{children}</main>
      </div>

      {showLogoutModal && (
        <div className={styles.confirmBackdrop}>
          <div className={styles.confirmModal}>
            <h4>Logout</h4>
            <p>Are you sure you want to logout?</p>
            <div className={styles.confirmActions}>
              <button className={styles.secondaryBtn} onClick={cancelLogout}>
                Cancel
              </button>
              <button className={styles.primaryBtn} onClick={confirmLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
